<template>
	<div>
    <!-- 邀请卡 -->
    <van-dialog class="invite-dialog" v-model="inviteCardShow" width="285px" :show-confirm-button="false">
			<div class="invite-card">
				<div class="invite-img">
					<img :src="liveinfo.poster_cover" alt="" />
				</div>
				<span
					>已成功邀请<span style="color: red">{{ myRank.invite_num != null ? myRank.invite_num : 0 }}</span
					>人</span
				>
                    <span v-if="myRank.invite_num == 0">暂未上榜</span>
                    <span v-else>排行<span style="color: red">{{ myRank.ranking }}</span>名
				</span>
				<div class="bottom-button">
					<div class="button" @click="inviteNows">立即邀请</div>
					<div class="button" @click="openRank">查看榜单</div>
				</div>
				<div class="delButton" @click="fnCloseinviteCard" ><van-icon name="cross" color="#aaa" /></div>
			</div>
		</van-dialog>
    <!-- 去邀请 -->
		<van-dialog class="to-invite-dialog invite-poster"  v-model="toInviteShow" width="250px" :show-confirm-button="false">
			<div class="poster">
				<!-- <div class="left">
					<div class="img-left">
						<img :src="userinfo != null ? userinfo.avatar : ''" alt="" />
					</div>
					<div class="desc-content">
						<div class="title">{{ userinfo != null ? userinfo.name : "" }}</div>
						<div class="desc">邀你一起看直播</div>
					</div>
				</div> -->
				<invitation-card :param="invitationCard" @get-image="getInivteImage"></invitation-card>
			</div>
			<div class="save-notice">
				<img src="../assets/images/copy-icon.png" style="width: 25px; height: 25px; margin-right: 15px" alt="" />长按图片保存邀请卡片
			</div>
			<div class="delButton poster-button" @click="toInviteShow=false" ><van-icon name="cross" color="#aaa" /></div>
		</van-dialog>
    <van-popup class="to-invite-content" :overlay="false" v-model="toInviteShow" position="bottom" round :style="{ height: '16%' }">
			<!-- <div class="title">点击切换海报样式</div> -->
			<div class="poster">
				<div class="posterList">
					<div class="poster-item" @click="choosePoster(index)" v-for="(item, index) in liveinfo.poster" :key="index">
						<img :src="item.url" alt="" />
						<div class="choosed-mark" v-if="posterIndex === index">
							<van-icon style="margin-left: 2px" name="success" color="#fff" size="8" />
						</div>
					</div>
				</div>
				<div class="qrCode" @click="activeQrShow = true" style="margin-right: 15px">
					<img src="../assets/images/qrcode.png" style="width: 25px; height: 25px" alt="" />
					<span style="font-size: 12px">二维码</span>
				</div>
			</div>
		</van-popup>
    <!-- 活动二维码 -->
		<van-popup class="active-qr" v-model="activeQrShow" position="bottom" round>
      <div class="delButton" @click="activeQrShow = false"><van-icon name="cross" color="#aaa" /></div>
			<div class="title">
				<div style="height: 25px; width: 80px"><img style="width: 100%; height: 100%" src="../assets/images/share-square.png" alt="" /></div>
				<span style="font-size: 16px; font-weight: 550">保存二维码或链接分享</span>
				<div style="height: 25px; width: 80px"><img style="width: 100%; height: 100%" src="../assets/images/share-square - right.png" alt="" /></div>
			</div>
			<div class="qrcode">
				<vue-qr ref="qr" :margin="5" :text="share_url" :size="100"></vue-qr>
			</div>
			<span class="desc">长按即可保存活动二维码</span>
			<div class="link" style="display: flex;">
				<van-form>
					<van-field v-model="share_url" :disabled="true"></van-field>
				</van-form>

				<div
					class="copy"
					v-clipboard:copy="liveinfo.share_url"
					v-clipboard:success="onCopy"
					v-clipboard:error="onError"
				>
					复制
				</div>
			</div>
		</van-popup>
  </div>
</template>

<script>

import InvitationCard from "./common/InvitationCard.vue";
import vueQr from "vue-qr";
export default {
	data() {
		return {
			invitationCard: {
				image: "",
				qrcode: { url: "" },
			},
			toInviteShow:false,
			posterIndex: 0,
			activeQrShow:false
		};
	},
  components: {
		InvitationCard,
		vueQr,
	},
	props:{
		inviteCardShow:{
				type:Boolean,
				default:false
		},
		liveinfo:{
				type:Object,
				default:()=>{}
		},
		myRank:{
				type:Object,
				default:()=>{}
		},
		userinfo:{
				type:Object,
				default:()=>{}
		},
		share_url:{
				type:String,
				default:""
		}
  },
	mounted() {
		
	},
	methods: {
		//立即邀请
		inviteNows() {
			if (!this.userinfo || !this.userinfo.avatar) {
				this.$toast('用户信息加载中，请稍后重试')
				return
			}
			if (!this.share_url) {
				this.$toast('分享链接未就绪，请稍后重试')
				return
			}
			this.toInviteShow = true;
			this.fnCloseinviteCard()
			setTimeout(() => {
				this.invitationCard = {
					image: this.liveinfo.poster[this.posterIndex].url + `?${Math.random()}`,
					qrcode: {
						url: this.share_url,
					},
					avatar: this.userinfo.avatar,
					nickname: this.userinfo.nick_name,
				};
				console.log("openInviteCard", this.invitationCard);
			}, 50);
		},
		openRank(){
			this.$emit("fnopenRank")
		},
    choosePoster(index) {
			this.posterIndex = index;
			setTimeout(() => {
				this.invitationCard = {
					image: this.liveinfo.poster[this.posterIndex].url + `?${Math.random()}`,
					// image: this.liveinfo.poster[this.posterIndex].base64,
					qrcode: {
						url: this.share_url,
					},
                    avatar: this.userinfo.avatar,
					nickname: this.userinfo.nick_name,
				};
				console.log("choosePoster", this.invitationCard);
			}, 50);
		},
    onCopy() {
			this.$toast("复制成功");
		},
		onError() {
			this.$toast({
				message: '<div style="height:40px;with:70px;display:flex;align-items:center;justified-content:center">复制失败</div>',
				type: "html",
			});
		},
    getInivteImage(dataurl) {
			// console.log("邀请卡图片数据", dataurl);
		},
		fnCloseinviteCard(){
			this.$emit('update:inviteCardShow',false)
		},
	},
};
</script>

<style lang="less" scoped>
    // 邀请卡
.invite-dialog {
	border-radius: 20px;
	&.van-dialog {
		overflow: visible !important;
	}
	.invite-card {
		position: relative;
		display: flex;
		flex-direction: column;
		align-items: center;
		box-sizing: border-box;
		padding-bottom: 20px;

		.invite-img {
			width: 100%;
			height: 162px;
			border-radius: 20px 20px 0 0;
			img {
				width: 100%;
				height: 100%;
				border-radius: 20px 20px 0 0;
			}
		}
		span {
			margin-top: 15px;
		}
		.bottom-button {
			display: flex;
			margin-top: 15px;
			.button {
				color: #fff;
				background-color: #1ab4ec;
				display: flex;
				justify-content: center;
				align-items: center;
				border-radius: 5px;
				font-size: 12px;
				height: 32px;
				width: 68px;
				&:last-child {
					margin-left: 25px;
				}
			}
		}
		.delButton {
			position: absolute;
			border: 1px solid #fff;
			border-radius: 50%;
			display: flex;
			align-items: center;
			justify-content: center;
			height: 30px;
			width: 30px;
			left: 47%;
			top: 105%;
			& .poster-button {
				top: 98%;
			}
		}
	}
}
//邀请榜单
.invite-content {
	.content {
		position: relative;
		height: 100%;
		width: 100%;
		box-sizing: border-box;
		padding: 0 0 70px 0;
		.invite-rank {
			box-sizing: border-box;
			padding-bottom: 70px;
		}
		.invite-item {
			display: flex;
			justify-content: space-between;
			align-items: center;
			height: 50px;
			box-sizing: border-box;
			padding: 0 30px;
			.left {
				height: 100%;
				display: flex;
				align-items: center;
				.rank {
					display: flex;
					justify-content: center;
					align-items: center;
					height: 43px;
					width: 33px;
					&.first {
						background: url("../assets/images/rank-1.png");
						background-size: 100% 100%;
					}
					&.second {
						background: url("../assets/images/rank-2.png");
						background-size: 100% 100%;
					}
					&.third {
						background: url("../assets/images/rank-3.png");
						background-size: 100% 100%;
					}
				}
				.img-left {
					margin-left: 15px;
					height: 40px;
					width: 40px;
					border-radius: 50%;
					img {
						width: 100%;
						height: 100%;
						border-radius: 50%;
					}
				}
				span {
					margin-left: 20px;
					width: 110px;
					overflow: hidden;
					white-space: nowrap;
					text-overflow: ellipsis;
					    text-align: left;
				}
			}
		}
		.my-info {
			position: fixed;
			width: 100%;
			box-sizing: border-box;
			padding: 0 10px;
			left: 0;
			bottom: 0;
			height: 70px;
			width: 100%;
			background-color: #fff;
			border-top: 1px solid #ddd;
			display: flex;
			justify-content: space-between;
			align-items: center;
			.left {
				display: flex;
			}
			.img-left {
				height: 40px;
				width: 40px;
				border-radius: 50%;
				img {
					width: 100%;
					height: 100%;
					border-radius: 50%;
				}
			}
			.desc-content {
				margin-left: 10px;
				.title {
					text-align: left;
					font-size: 16px;
					font-weight: 550;
				}
				.desc {
					text-align: left;
					margin-top: 10px;
					font-size: 12px;
				}
			}
			.follow {
				background: #1ab4ec;
				color: #fff;
				box-sizing: border-box;
				padding: 8px 12px;
				font-size: 16px;
				border-radius: 10px;
				display: flex;
				justify-content: center;
				align-items: center;
			}
		}
	}
}
.to-invite-dialog {
	position: relative;
	&.van-dialog {
	&.invite-poster {
		height: 430px;
		background: none;
		// overflow: hidden;
	}
		overflow: visible;
		position: fixed;
		top: 45%;
		left: 50%;
		&.redpacket {
			width: 277px;
		}
	}
    //海报
	.poster {
		position: relative;
		height: 425px;
		width: 100%;
		border-radius: 10px;
		background-color: #fff;
		.bc-img {
			height: 500px;
			width: 100%;
		}
		img {
			width: 100%;
			height: 100%;
			border-radius: 10px;
		}
		.qrcode {
			position: absolute;
			bottom: 10px;
			right: 10px;
			height: 70px;
			width: 70px;
			img {
				height: 100%;
				width: 100%;
			}
		}
		.left {
			// position: absolute;
			// top: 10px;
			// left: 10px;
			display: flex;
			color: #fff;
		}
		.img-left {
			height: 40px;
			width: 40px;
			border-radius: 50%;
			img {
				width: 100%;
				height: 100%;
				border-radius: 50%;
			}
		}
		.desc-content {
			margin-left: 10px;
			color: #000;
			.title {
				text-align: left;
				font-size: 12px;
				margin-top: 5px;
			}
			.desc {
				text-align: left;
				margin-top: 5px;
				font-size: 12px;
			}
		}
	}
    .save-notice {
		display: flex;
		align-items: center;
		position: absolute;
		display: flex;
		align-items: center;
		justify-content: center;
		height: 45px;
		width: 236px;
		border-radius: 25px;
		font-size: 16px;
		font-weight: 550;
		color: #fff;
		background: linear-gradient(to right, #51f1ff, #00abea);
		left: 50%;
		transform: translateX(-50%);
		top: -15%;
	}
	.delButton {
		position: absolute;
		border: 1px solid #fff;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		height: 30px;
		width: 30px;
		right:-30px;
		top: -25px;
		
	}

}
.to-invite-content {
	.title {
		margin-top: 10px;
		font-size: 14px;
	}
	.poster {
		box-sizing: border-box;
		margin-right: 10px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding-top: 12px;
		.posterList {
			display: flex;
			.poster-item {
				position: relative;
				overflow: hidden;
				margin-left: 10px;
				height: 58px;
				width: 58px;
				border: 1px dashed #ccc;
				padding: 2px;
				box-sizing: border-box;
				border-radius: 4px;
				img {
					width: 100%;
					height: 100%;
					object-fit: contain;
				}
				.choosed-mark {
					position: absolute;
					text-align: left;
					background-color: blue;
					width: 30px;
					height: 30px;
					border-radius: 15px;
					border: 2px solid #fff;
					right: -15px;
					bottom: -15px;
				}
			}
		}
		.qrCode {
			width: 48px;
			display: flex;
			flex-direction: column;
			align-items: center;
			span {
				margin-top: 10px;
				color: #bbb;
			}
		}
	}
}
.active-qr {
	display: flex;
	flex-direction: column;
	align-items: center;
	.title {
		display: flex;
		align-items: center;
		margin-top: 35px;
	}
	.qrcode {
		margin-top: 20px;
		height: 145px;
		width: 145px;
		img {
			width: 100%;
			height: 100%;
		}
	}
	.desc {
		color: #bbb;
		margin-top: 20px;
	}
	.link {
		margin-top: 20px;
		width: 90%;
		display: flex;
		align-items: center;
		span {
			color: #bbb;
			font-size: 16px;
		}
		.copy {
			color: blue;
			font-size: 14px; 
			width: 50px;
		}
		.van-form{
			width: 90%;
		}
	}
    .delButton{
        font-size: 20px;
        position: absolute;
        right: 12px;
        top: 10px;
    }
}
</style>
